<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <el-row type="flex">
        <el-button size="mini" class="btn" type="primary" @click="$router.go(-1)">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </el-row>
      <el-form label-width="140px" ref="applyInfoForm" :model="headData" class="topform">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="报价确认单据编号">
              <el-input class="handle-input" v-model="headData.sourcingNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('nav.productQuotationApplication')">
              <el-input class="handle-input" v-model="headData.applyNo" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="主题">
              <el-input class="handle-input" v-model="headData.subject" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建人">
              <el-input class="handle-input" v-model="headData.creater" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建日期">
              <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="headData.createDate" disabled style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品报价明细" name="first">
        <ux-grid ref="dataTable" :data="tableData" keep-source max-height="550" show-overflow="tooltip" highlight-current-row>
          <ux-table-column align="center" v-for="(item,index) in columns" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
          <ux-table-column field="effectiveBeginDate" title="有效开始日期" min-width="130" resizable align="center" sortable>
            <template v-slot="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </ux-table-column>
          <ux-table-column field="isSpecialFreight" title="非标准线路运费" min-width="150" resizable align="center" sortable>
            <template v-slot="scope">
              {{scope.row.isSpecialFreight == "Y" ? "是" : "否"}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" v-for="(item,index) in columns1" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
        </ux-grid>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="log">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip sortable prop="operatorName" align="center" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="createDate" align="center" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">
              {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="action" align="center" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="comments" align="center" :label="$t('common.remarks') "></el-table-column>

        </el-table>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import { getSourcingList, sourcingSubmit } from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import sourcingProductApi from "@/api/quoteByProduct/sourcingProduct";
import { fileService } from "@/api/common/file-utils";
export default {
  name: "sourcingByProductDetail",
  data() {
    return {
      columns: [
        { prop: "itemSequence", label: this.$t('quoteByLine.sourcing.itemNo'), width: "80" },
        { prop: "supplierName", label: "最终供应商", width: "120" },
        { prop: "eightBitCode", label: "8位码", width: "90" },
        { prop: "eightBitCodeName", label: "8位码名称", width: "150" },
        { prop: "productPrice", label: "产品运费（不含税）", width: "180" },
        { prop: "currentProductPrice", label: "现有产品价格", width: "150" },
        { prop: "changeRate", label: "价格变化", width: "110" },
      ],
      columns1: [
        { prop: "pickupPoint", label: "发货市", width: "100" },
        { prop: "dcName", label: "到货仓库", width: "110" },
        { prop: "temperatureI18n", label: "温区", width: "80" },
        { prop: "transportaionMethodI18n", label: "运输方式", width: "100" },
        { prop: "unitI18n", label: "结算单位", width: "100" },
        { prop: "linePrice", label: "线路价格", width: "100" },
        { prop: "currencyCode", label: "币种", width: "80" },
        { prop: "leadTime", label: "LeadTime", width: "120" },
        { prop: "remarks", label: this.$t('common.remarks'), width: "120" },
        { prop: "estimatedAnnualFee", label: this.$t('apply.estimatedAnnualTotalCost'), width: "150" },
      ],
      activeName: 'first',
      queryCondition: {
        pageNum: 1, //当前页
        pageSize: 0, //每页多少条
        isSpecialFreight: null,
        sourcingNo: null,
        applyNo: null,
        title: null,
        isSpecialFreight: null,
        tmSupplierId: null,
        createBy: null,
        dateFrom: null,
        dateTo: null
      },
      auditLog: [],
      tableData: [],
      radioVal: null,
      selectRow: null,
      ttQuotationId: "",
      headData: {},
      sourcingNo: "",
      proList: [],
      fileList: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      }
    };
  },
  created() {
    this.queryCondition.sourcingNo = this.$route.query.sourcingNo;
    this.initData();
  },
  methods: {
    initData: function () {
      let _this = this;
      sourcingProductApi.list(this.queryCondition).then(resp => {
        this.tableData = resp.resultData;
        this.auditLog = resp.logs;
        this.headData = resp.resultData[0]
      })
    },
  }
};
</script>
<style lang="scss">
.productQuotationApplicationAdd .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
</style>
